import { FeatureFlagsContext } from "contexts/FeatureFlagProvider";
import React from "react";

export const useFeatureFlags = (): React.ContextType<typeof FeatureFlagsContext> =>
  React.useContext(FeatureFlagsContext);
